module.exports = __webpack_public_path__ + "static/media/35.f10bb40c.png";